export function selectAll(event) {
    const element = getSelectableElement(event?.target) ?? getSelectableElement(event?.currentTarget)
    if (!element) return

    try {
        element.setSelectionRange(0, `${element.value ?? ""}`.length)
    } catch {
        // Some input types expose setSelectionRange but do not allow selection.
    }
}

function getSelectableElement(element) {
    if (!element) return null
    if (typeof element.setSelectionRange === "function") return element
    if (typeof element.querySelector !== "function") return null
    return element.querySelector("input, textarea")
}
